import axiosInstance from "@/utils/axiosInstance";

const baseUrl: string = "api/public/companies";

const state = {};

const getters = {};

const mutations = {};

const actions = {
  create({commit}, payload: {
    company: number,
    master: object,
  }) {
    return axiosInstance.post(`${baseUrl}`, payload)
      .then((data) => data.data);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
